import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { AgExportComponent } from './ag-export.component';
import { CovanceAgGridHelper } from './covance-ag-grid-helper';
import { CovanceAgGridComponent } from './covance-ag-grid.component';
import { BooleanAgFloatingFilterComponent } from './filters/boolean-ag-floating-filter.component';
import { BooleanFilterComponent } from './filters/boolean-filter.component';
import { FilterHeaderComponent } from './filters/filter-header.component';
import { BarRendererComponent } from './renderers/bar-renderer.component';
import { CellTooltipAgRendererComponent } from './renderers/cell-tooltip-ag-renderer.component';
import { HeaderGroupRenderer } from './renderers/header-group-renderer.component';
import { HeaderTooltipAgRendererComponent } from './renderers/header-tooltip-ag-renderer.component';
import { HiddenDocumentAgRendererComponent } from './renderers/hidden-document-ag-renderer.component';
import { HiddenEQUeryAgRendererComponent } from './renderers/hidden-e-query-ag-renderer.component';
import { LinkAgRendererComponent } from './renderers/link-ag-renderer.component';
import { MulticellAgRendererComponent } from './renderers/multicell-ag-renderer.component';
import { MultilineAgRendererComponent } from './renderers/multiline-ag-renderer.component';
import { TestLinkAgRendererComponent } from './renderers/test-link-ag-renderer.component';
import { TextListAgRendererComponent } from './renderers/text-list-ag-renderer.component';
import { ViewHistoryAgRendererComponent } from './renderers/view-history-ag-renderer.component';
import { DetailModalPopupAgRendererComponent } from './renderers/detail-modal-popup-renderer.component';
import {AgeRendererComponent} from './renderers/age-renderer/age-renderer.component';
import {ResponseAgeRendererComponent} from './renderers/response-age-renderer/response-age-renderer.component';

@NgModule({
    declarations: [
        CovanceAgGridComponent,
        LinkAgRendererComponent,
        TextListAgRendererComponent,
        MultilineAgRendererComponent,
        MulticellAgRendererComponent,
        ViewHistoryAgRendererComponent,
        BooleanFilterComponent,
        AgExportComponent,
        CellTooltipAgRendererComponent,
        BarRendererComponent,
        HeaderTooltipAgRendererComponent,
        HeaderGroupRenderer,
        TestLinkAgRendererComponent,
        FilterHeaderComponent,
        HiddenDocumentAgRendererComponent,
        HiddenEQUeryAgRendererComponent,
        BooleanAgFloatingFilterComponent,
        DetailModalPopupAgRendererComponent,
        AgeRendererComponent,
        ResponseAgeRendererComponent
    ],
    imports: [
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [CovanceAgGridComponent, AgExportComponent, FilterHeaderComponent],
    providers: [CovanceAgGridHelper],
    entryComponents: [
        LinkAgRendererComponent,
        TextListAgRendererComponent,
        MultilineAgRendererComponent,
        MulticellAgRendererComponent,
        ViewHistoryAgRendererComponent,
        BooleanFilterComponent,
        CellTooltipAgRendererComponent,
        BarRendererComponent,
        HeaderTooltipAgRendererComponent,
        HeaderGroupRenderer,
        TestLinkAgRendererComponent,
        FilterHeaderComponent,
        HiddenDocumentAgRendererComponent,
        HiddenEQUeryAgRendererComponent,
        BooleanAgFloatingFilterComponent,
        DetailModalPopupAgRendererComponent,
        AgeRendererComponent,
        ResponseAgeRendererComponent
    ]
})
export class CovanceAgGridModule { }
